<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Fees Reports",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Fees Periodic Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Periodic Report",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Student Name",
          sortable: true,
        },
        {
          key: "class",
          label: "Class",
          sortable: true,
        },
        {
          key: "term",
          label: "Term",
          sortable: true,
        },
        {
          key: "amount",
          label: "Amount",
          sortable: true,
        },
        {
          key: "mode",
          label: "Payment Mode",
          sortable: true,
        },
        {
          key: "date",
          label: "Payment Date",
          sortable: true,
        },
        {
          key: "receipt",
          label: "Receipt No",
          sortable: true,
        },
        {
          key: "paidby",
          label: "Paid By",
          sortable: true,
        },
      ],
      data: {
        class: 0,
        from: "",
        to: moment(new Date()).format("YYYY-MM-DD"),
      },
      assigned: [],
    };
  },
  computed: {
    ...mapGetters("fees", ["PeriodicReport", "SaveStatus"]),
    ...mapGetters("classes", ["AllClasses"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.assigned ? this.assigned.length : 1;
    },
  },
  watch: {
    PeriodicReport(newValue) {
      if (newValue) {
        this.assign();
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.assigned ? this.assigned.length : 1;
  },
  methods: {
    ...mapActions({
      FetchPayments: "fees/fetchPeriodicReport",
      FetchClasses: "classes/fetchClasses",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.assigned ? this.assigned.length : 1;
      this.currentPage = 1;
    },
    fetch_payments() {
      this.FetchPayments(this.data);
    },
    assign() {
      this.assigned = this.PeriodicReport;
    },
  },
  created() {
    this.FetchClasses();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <label>Class</label>
                <div class="input-group">
                  <select class="form-control" v-model="data.class">
                    <option value="0">All Classes</option>
                    <option
                      v-for="(t, index) in AllClasses"
                      :key="index"
                      :value="t.id"
                    >
                      {{ t.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="col-form-label"
                    >From <span class="required">*</span></label
                  >
                  <input type="date" class="form-control" v-model="data.from" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="col-form-label">
                    To <span class="required">*</span></label
                  >
                  <input type="date" class="form-control" v-model="data.to" />
                </div>
              </div>
              <div class="col-md-3 mt-2">
                <br />
                <button class="btn btn-success" @click="fetch_payments()">
                  <i class="fa fa-search"></i> Search
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Spinning"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="assigned ? assigned.payments : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>
              <table
                width="100%"
                style="
                  border-top: 1px solid #ccc;
                  border-bottom: 1px solid #ccc;
                "
              >
                <tr>
                  <td width="50%"><h2>TOTAL</h2></td>
                  <td width="50%">
                    <h2>{{ assigned.tot }}/=</h2>
                  </td>
                </tr>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.required {
  color: red !important;
}
/* .custom{
    width: 350px;
} */
</style>
